import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { Toast, ToastKind } from './toast.model';

const AUTO_DISMISS_MS = 4000;

/**
 * One toast at a time, bottom-left, auto-dismissing — mirrors the mockup's showToast().
 */
@Injectable({ providedIn: 'root' })
export class ToastService {
  private readonly toastSubject = new BehaviorSubject<Toast | null>(null);
  readonly toast$ = this.toastSubject.asObservable();

  private dismissTimer: ReturnType<typeof setTimeout> | null = null;

  show(message: string, kind: ToastKind = 'success'): void {
    if (this.dismissTimer) {
      clearTimeout(this.dismissTimer);
    }
    this.toastSubject.next({ message, kind });
    this.dismissTimer = setTimeout(() => this.dismiss(), AUTO_DISMISS_MS);
  }

  dismiss(): void {
    if (this.dismissTimer) {
      clearTimeout(this.dismissTimer);
      this.dismissTimer = null;
    }
    this.toastSubject.next(null);
  }
}
